import styled, { css } from "styled-components";
import { border, boxShadow, color, typeStyle, units, variant } from "@m/alchemy-theme";
export const PanelWrapper = styled.div `
  color: ${color("typeBody")};
  height: 100%;
  width: ${({ panelWidth }) => `${panelWidth}px`};
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  ${typeStyle("bodyS")};

  ${() => css `
    ${variant("variant", {
    configuration: css `
        background-color: ${color("container")};
        border: ${border()};
        box-shadow: ${boxShadow()};
      `,
    outline: css `
        background-color: ${color("canvas")};
      `,
    summary: css `
        border: ${border()};
        background-color: ${color("container")};
      `
})}
  `};
`;
export const Header = styled.div `
  border-bottom: ${border()};
  ${({ hasContentShadow }) => hasContentShadow &&
    `box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 5px 8px -2px, rgba(0, 0, 0, 0.18) 0px 0px 1px 0px;`};
  z-index: 1;
`;
export const Content = styled.div `
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;

  ${({ isLoading }) => isLoading && "position: relative;"}
  ${({ isContentFlex, isLoading }) => isContentFlex &&
    !isLoading &&
    `display: flex;
    flex-grow: 1;
    max-width: 100%;
  `};

  ${({ isContentFlex, flexDirection }) => isContentFlex && flexDirection && `flex-direction: ${flexDirection}`};
`;
export const Footer = styled.div `
  border-top: ${border()};
  ${({ hasContentShadow }) => hasContentShadow &&
    `box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 5px 0px, rgba(0, 0, 0, 0.1) 0px 5px 8px -2px, rgba(0, 0, 0, 0.18) 0px 0px 1px 0px`};
  z-index: 1;
`;
export const Separator = styled.div `
  ${typeStyle("bodyS")};
  display: flex;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${color("typeMeta")};
  text-align: center;
  line-height: 1;
  -webkit-box-align: center;
  align-items: center;

  :before,
  :after {
    content: " ";
    flex: 1 1 0%;
    border-top: 1px solid ${color("line")};
  }

  :before {
    margin-right: ${units(2)};
  }

  :after {
    margin-left: ${units(2)};
  }
`;
